import DrilldownTable from '../../components/TableUtmDeal/TableUtmDeal';
import { useStores } from '../../hooks/useStore';
import styles from './DealsUTM.module.css';
import { observer } from 'mobx-react';
// import { LineChart } from '@mui/x-charts/LineChart';
require('moment/locale/ru');

const DealsByUtmPage: React.FC = observer(() => {
  // const api = useApi();
  const store = useStores();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.pageName}>
          <div className={styles.top}>
            <div className={styles.title}>
              <h2>Сделки по UTM</h2>
            </div>
          </div>
        </div>

        <div>
          <DrilldownTable
            startDate={store.dateStore.startDate}
            endDate={store.dateStore.endDate}
          />
        </div>
      </div>
    </>
  );
});

export default DealsByUtmPage;
